import React from 'react'

// components
import {
  CRow,
  CCol,
} from '@coreui/react-pro'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormSelectInput from '../general-input-form/FormSelectInput'
import FormNumberInput from '../general-input-form/FormNumberInput'
import AppTextColumnDetails from '../../details/general-details/AppTextColumnDetails'

// helpers
import { singleTimeOffApprovalTypeOptionSelect, singleTimeOffApprovalUnpaidCategoryOptionSelect } from 'src/helpers/format-options'

const AppFormPendingApproval = ({
  values,
  handleChange,
  approvalRequestValue,
  handleSelectApprovalRequest,
  handleSelectUnpaidCategory,
  errors
}) => {
  return (
    <>
      <CRow className="mb-3 justify-content-center">
        <AppTextColumnDetails
          colSize="3"
          title="Time-Off Type"
          subtitle={values?.type ? `${values?.type}` : "-"}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Time-Off Duration"
          subtitle={values?.duration ? values?.code == "EMERGENCY" ? values?.is_emergency_over_4_hours ? `${values?.duration} Days (>4 Hours)` : `${values?.duration} Days (<4 Hours)` : `${values?.duration} Days` : "-"}
        />
        {
          (values?.code == 'SICK' || values?.code == 'BEREAVEMENT') && (
            <AppTextColumnDetails
              colSize="3"
              title="Available Balance"
              subtitle={values?.available_balance ? `${values?.available_balance} Days` : "-"}
            />
          )
        }
        {
          values?.code == 'EMERGENCY' && (
            <AppTextColumnDetails
              colSize="3"
              title="Notes"
              subtitle={values?.notes ? `${values?.notes}` : "-"}
            />
          )
        }
      </CRow>
      <CRow className={`mb-3 ${approvalRequestValue ? '' : 'justify-content-center'}`}>
        <FormSelectInput
          id='approval_request'
          name='approval_request'
          colSize='6'
          inputLabel='Approval Decision'
          className='mb-3'
          selectOptions={singleTimeOffApprovalTypeOptionSelect()}
          value={singleTimeOffApprovalTypeOptionSelect().find(option => option.value === approvalRequestValue) || null}
          handleSelectInput={handleSelectApprovalRequest}
          feedbackInvalid={errors?.approval_request}
          invalid={errors?.approval_request}
          disabled={false}
          placeholder='Please select...'
        />
        {
          (values?.code == 'SICK' || values?.code == 'BEREAVEMENT') && approvalRequestValue === "approved" && (
            <CCol lg={6} className='mb-3'>
              <FormNumberInput
                id='approval_days'
                name='approval_days'
                colSize='12'
                inputLabel='Approval Days'
                className='mb-3'
                placeholder='Enter approval days...'
                value={values?.approval_days}
                handleChange={handleChange}
                feedbackInvalid={errors?.approval_days}
                invalid={errors?.approval_days}
                max={values?.duration}
                min={values?.duration > values?.available_balance ? Number(values?.duration) - Number(values?.available_balance) : 1}
              />
              {
                values?.duration > values?.available_balance && (
                  <small className='text-danger'>
                    The number of approval days must range from ({Number(Number(values?.duration) - Number(values?.available_balance))}) to ({values?.duration}).
                  </small>
                )
              }
            </CCol>
          )
        }
        {approvalRequestValue === "approved" && (
          <>
            {
              values?.code == 'UNPAID' && (
                <CCol lg={6} className='mb-3'> 
                  <FormSelectInput
                    id='unpaid_category'
                    name='unpaid_category'
                    colSize='12'
                    inputLabel='Unpaid Category'
                    className='mb-3'
                    selectOptions={singleTimeOffApprovalUnpaidCategoryOptionSelect()}
                    value={singleTimeOffApprovalUnpaidCategoryOptionSelect().find(option => option.value === values.unpaid_category) || null}
                    handleSelectInput={handleSelectUnpaidCategory}
                    feedbackInvalid={errors?.unpaid_category}
                    invalid={errors?.unpaid_category}
                    disabled={false}
                    placeholder='Please select...'
                  />
                  {
                    !values?.is_available_balance && (
                      <small className='text-danger'>Attention: Employee annual leave balance exhausted. Excess days will be processed as Unpaid Leave (Loss of Pay) with payroll wage deductions applied.</small>
                    )
                  }
                </CCol>
              )
            }
            <FormTextAreaInput
              id='approval_notes'
              name='approval_notes'
              colSize='6'
              inputLabel='Approval Notes'
              className='mb-3'
              placeholder='Enter approval notes...'
              rows='3'
              value={values?.approval_notes}
              handleTextAreaInput={handleChange}
              feedbackInvalid={errors?.approval_notes}
              invalid={errors?.approval_notes}
            />
          </>
        )}
        {approvalRequestValue === "decline" && (
          <FormTextAreaInput
            id='decline_reason'
            name='decline_reason'
            colSize='6'
            inputLabel='Decline Reason'
            className='mb-3'
            placeholder='Enter decline reason...'
            rows='3'
            value={values?.decline_reason}
            handleTextAreaInput={handleChange}
            feedbackInvalid={errors?.decline_reason}
            invalid={errors?.decline_reason}
          />
        )}
      </CRow>
    </>
  )
}

export default AppFormPendingApproval
